import React from "react";
function HeaderLower() {
  return (
    <div className="header_lower">
      <div className="box-text">
        Win a Trip To Las Vegas Getaway! (Retail Value $5,000).
      </div>
      <span className="below-enter">ENTER BELOW</span>
    </div>
  );
}
export default HeaderLower;
